import React, { useState, useEffect, useContext } from "react";
import axios from "axios";
import styled from "styled-components";
import { NotificationManager } from "react-notifications";
import { Navigate } from 'react-router-dom';
import moment from "moment";
import {
  TextInput,
} from "components/Input/Index.js";
import DateInput from "components/Input/DateInput.js";
import CustomSelect from "components/Input/CustomSelect.js";
import Button from "@mui/material/Button";
import { makeStyles } from "@mui/styles";
import ImageList from "@mui/material/ImageList";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import UserService from "services/UserService";
import { budgetpagetext } from "variables/budget";
import { statusData } from "variables/lists/budget";
import { postBudget } from "services/ConfigServices";
import AdvancedSearchContext from "context/AdvancedSearchContext";

const useStyles = makeStyles((theme) => ({
  root: {
    "& .MuiTextField-root": {
      margin: '16px',
      marginTop: "1rem",
      //width: "30ch",
    },
  },
  formControl: {
    margin: 8,
    width: "62ch",
  },
  gridList: {
    width: 330,
    height: 400,
    //marginLeft: "-2rem",
  },
  treeVisible: {
    display: "block",
  },
  treeHidden: {
    display: "none",
  },
  textField: {
    fontSize: "14px",
    fontFamily: '"Source Sans Pro",sans-serif',
    "& .MuiInputBase-input": {
      fontSize: "14px",
      fontFamily: '"Source Sans Pro",sans-serif',
    },
  },
  submitButton: {
    color: "#FFFFFF",
    backgroundColor: "#91C73C",
    fontWeight: "bold",
    display: "block",
    marginTop: "15px",
    marginRight: "auto",
    marginLeft: "22px",
    width: "61.5ch",
    "&:hover": {
      backgroundColor: "#91C73C",
      boxShadow: "0px 11px 15px -7px rgb(0 0 0 / 20%)",
    },
  },
  submitButtonDisabled: {
    color: "#FFFFFF",
    backgroundColor: "#9798A0",
    fontWeight: "bold",
    display: "block",
    marginTop: "15px",
    marginRight: "auto",
    marginLeft: "22px",
    width: "61.5ch",
  },
}));

const TreeLabel = styled.div`
  font-size: 14px;
  font-weight: 600;
  opacity: 1;
  font-family: "Source Sans Pro", sans-serif;
`;

function CreateBudgetDialog(props) {
  const appContext = useContext(AdvancedSearchContext);
  const { chartIdGroup,setPage } = appContext;
  const [name, setName] = useState("");
  const [datebegin, setDatebegin] = useState("");
  const [dateend, setDateend] = useState("");
  const [code, setCode] = useState("");
  const [perimeter, setPerimeter] = useState("");

  const [redirState, setRedirState] = useState(false);
  const [budgetId, setBudgetId] = useState("");

  const [buttonDisabled, setButtonDisabled] = useState(true);

  useEffect(() => {
    if (
      name.length > 0 
    ) {
      setButtonDisabled(false);
    } else {
      setButtonDisabled(true);
    }
  }, [name]);

  let redirecting = redirState && (
    <Navigate
      push
      to={{
        pathname: "/admin/budget/selectedbudget/",
        state: { budgetId, cpeName: name },
      }}
    />
  );

  const handleSubmit = async (event) => {
    createBudget(event);
  };

  const handleNameChange = (event) => { setName(event.target.value); };
  const handleDatebeginChange = (event) => { setDatebegin(event.target.value); };
  const handleDateendChange = (event) => { setDateend(event.target.value); };
  const handleCodeChange = (event) => { setCode(event.target.value); };
  const handlePerimeterChange = (event) => { setPerimeter(event.target.value); };

  const createBudget = async (event) => {
    let url = postBudget(chartIdGroup[0]);
    await axios
      .post(
        url,
        {
          general: {
            name,
            datebegin,
            dateend,
            code,
            perimeter
          },
        },
        {
          headers: {
            Authorization: `Bearer ${UserService.getToken()}`,
            'Content-Type': "application/json; charset=utf-8",
          },
        }
      )
      .then((res) => {
        setBudgetId(res.data.id);
        if (res.status == 200) {
          setNotification("success", "Budget créé");
        } else setNotification("error", "Une erreur est survenue");
      })
      .catch((error) => {
        setNotification("error", "Une erreur est survenue");
      });
    setRedirState(true);
  };

  const setNotification = (status, text) => {
    if (status === "success") {
      NotificationManager.success(text);
    } else {
      NotificationManager.error(text);
    }
  };

  const classes = useStyles();

  return (
    <>
      <form className={classes.root}>
        <GridContainer>
          <GridItem xs={12} sm={12} md={12} lg={12}>
            <div>
              <TextInput
                inputTitle={budgetpagetext.general.name}
                textInput={name}
                handleTextInputChange={handleNameChange}
                isRequired
              />
            </div>
            <div>
              <TextInput
                inputTitle={budgetpagetext.general.code}
                textInput={code}
                handleTextInputChange={handleCodeChange}
              />
            </div>
            <div>
              <DateInput
                inputTitle={budgetpagetext.general.datebegin}
                dateInput={datebegin}
                handleDateInputChange={handleDatebeginChange}
              />
            </div>
            <div>
              <DateInput
                inputTitle={budgetpagetext.general.dateend}
                dateInput={dateend}
                handleDateInputChange={handleDateendChange}
              />
            </div>
            <div>
              <TextInput
                inputTitle={budgetpagetext.general.perimeter}
                textInput={perimeter}
                handleTextInputChange={handlePerimeterChange}
              />
            </div>
            <Button
              disabled={buttonDisabled}
              className={
                buttonDisabled
                  ? classes.submitButtonDisabled
                  : classes.submitButton
              }
              onClick={() => {
                handleSubmit();
              }}
            >
              Créer
            </Button>
          </GridItem>
        </GridContainer>
      </form>
      {redirecting}
    </>
  );
}

export default CreateBudgetDialog;
